import { useMutation } from "@tanstack/react-query";
import { ImagesUpload } from "../../../Api/imageSelect";

export const useMutateCreateImage = () =>
  useMutation({
    mutationFn: (data) => ImagesUpload(data),
  });
